// Estilos y handlers para el botón del chat

export const chatButtonStyle = {
    position: 'fixed',
    bottom: '24px',
    right: '70px',
    background: 'linear-gradient(to bottom right, #2563eb, #1d4ed8)',
    color: 'white',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    border: 'none',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    zIndex: 50,
};

export const chatIconStyle = {
    width: '28px',
    height: '28px',
    color: 'white'
};

export const handleMouseEnter = (e) => {
    e.currentTarget.style.background = 'linear-gradient(to bottom right, #1d4ed8, #1e40af)';
    e.currentTarget.style.transform = 'scale(1.1)';
    e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
};

export const handleMouseLeave = (e) => {
    e.currentTarget.style.background = 'linear-gradient(to bottom right, #2563eb, #1d4ed8)';
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
};

export const handleMouseDown = (e) => {
    e.currentTarget.style.transform = 'scale(0.95)';
};

export const handleMouseUp = (e) => {
    e.currentTarget.style.transform = 'scale(1.1)';
};
